import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { getUserProfileSuccess } from 'actions/authenticate';
import { loadAuthToken } from 'utils/tokenStorage';
import Router from './Router';

interface IStateProps {
  userLoggedIn: boolean;
  profile: Nullable<UserProfileDTO>;
}

interface IDispatchProps {
  getUserProfileSuccess: (profile: UserProfileDTO) => void;
}

export const mapStateToProps: MapStateToProps<
  IStateProps,
  {},
  IRootStateType
> = (state: IRootStateType) => ({
  userLoggedIn: Boolean(state.authenticate.token || loadAuthToken()),
  profile: state.authenticate.profile,
});

const mapDispatchToProps: MapDispatchToProps<IDispatchProps, {}> = (
  dispatch: Dispatch,
): IDispatchProps =>
  bindActionCreators(
    {
      getUserProfileSuccess,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Router);
